import { FolkRope } from '../folk-rope';
FolkRope.define();
export { FolkRope };
//# sourceMappingURL=folk-rope.js.map